import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgGoogle({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2l.193.002.192.005.251.013.281.022.146.014.375.047.372.06.295.059a10 10 0 011.255.357l.373.141.356.152.32.15.31.16.305.17c.204.119.404.245.6.378l.19.132.136.1.2.152.25.202-2.561 3.072a6 6 0 101.736 6.835l.084-.223H12v-4h9.8c.131.646.2 1.315.2 2 0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgGoogle
